import React from 'react';
import PropTypes from 'prop-types';
import GenericMultiSelect from './GenericMultiSelect';
import { countryCodes } from '../../../shared/lib/country-codes-iso-alpha-2';
import { updateSyncMultiselect } from '../../../modules/DataExports/redux/actions';

const options = countryCodes.map(c => ({
  label: c.Name,
  value: c.Code,
}));

const CountryMultiSelect = props => (
  <div>
    <GenericMultiSelect
      action={updateSyncMultiselect}
      dispatch={props.dispatch}
      identifier={props.identifier}
      options={options}
      placeholder='Ex. United States or US'
      value={props.value}
    />
  </div>
);

CountryMultiSelect.propTypes = {
  dispatch: PropTypes.func,
  identifier: PropTypes.string,
  value: PropTypes.array,
};

export default CountryMultiSelect;



// WEBPACK FOOTER //
// ./src/components/lib/CountryMultiSelect.js